import { Button, Grid } from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SuperAdminTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "Dashboard", path: "/dashboardsuperadmin" },
    { label: "Financial Dashboard", path: "/financialdashboard" },
    { label: "Client/Org", path: "/createorganizationsview" },
    { label: "Trails", path: "/dashboardtrails" },
    { label: "Subscriptions", path: "/subscriptions" },
    { label: "Package", path: "/createpackage" },
    { label: "Module", path: "/module" },
  ];

  return (
    <Grid
      container
      sx={{
        background: "#F5F8FF",
        margin: { xs: "10px", sm: "10px", md: "10px" },
        width: "calc(100% - 20px)",
        borderRadius: "5px",
        padding: "10px",
        fontWeight: 600,
        display: "flex",
        flexWrap: "wrap",
        rowGap: 1.5,
        columnGap: 1.5,
      }}
    >
      {tabs.map((tab) => (
        <Grid item key={tab.path}>
          <Button
            variant="contained"
            size="medium"
            sx={{
              width: "100%",
              margin: 0,
              fontWeight: "inherit",
              background:
                location.pathname === tab.path ? "#33499F" : "#D2F0F4",
              color: location.pathname === tab.path ? "#fff" : "#000000",
              "&:focus": { outline: "none" },
              "&:hover": { color: "white", background: "#33499F" },
            }}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default SuperAdminTabs;
